<template>
    <b-form-group
        label-cols="12"
        label-cols-md="4"
        label-cols-xl="2"
        content-cols="12"
        content-cols-md="8"
        content-cols-xl="9"
        label="답변 필수 여부"
        :label-for="`editing-subs-${sub_code}-submit_required`"
        class="align-items-center mb-0"
        >
        <b-form-radio-group :id="`editing-subs-${sub_code}-submit_required`"
            v-model="selected"
            :options="options"
            />
        <div class="f-85 gray-600">캠페인의 '미답변 문항 제출 차단' 설정을 문항 단위로 덮어씁니다.</div>
    </b-form-group>
</template>
<script>
const { SUBMIT_REQUIRED_AUTO, SUBMIT_REQUIRED_OPTIONS } = require('@core/mixins/submit-required-override.cjs')

export default {
    name: 'EditingSubSubmitRequired',
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: SUBMIT_REQUIRED_AUTO
        }
    },
    data() {
        return {
            options: SUBMIT_REQUIRED_OPTIONS
        }
    },
    computed: {
        selected: {
            get() {
                return this.value
            },
            set(_value) {
                this.$emit('input', _value)
            }
        }
    }
}
</script>
